module.exports = __webpack_public_path__ + "c99158fab7c5c7c44e4de03b28379781.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-hansgrohe-bronze-brushed-140.png
// module id = Gx/S
// module chunks = 5